$(document).ready(function(){
  $('.collection-template-no-sidebar .pro-collection-slider, .list-collections-default .collection-item .img-box .img-box-slider').slick({
    infinite: false,
    slidesToShow: 1, 
    slidesToScroll: 1, 
    arrows: false, 
    dots: true
  });  

  var $temp = $("<input>");
  var $url = window.location.href;
  
  $('.link-copied').on('click', function() {
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
  })

  /*video modal script start*/
  jQuery('.video_mod').on('hide.bs.modal', function(e) {    
      var jQueryif = jQuery(e.delegateTarget).find('iframe');
      var src = jQueryif.attr("src");
      jQueryif.attr("src", '/empty.html');
      jQueryif.attr("src", src);
  });

  jQuery(".embed-responsive iframe").addClass("playyt_video");

  jQuery('#ply_icon').on('click', function(ev) {
     jQuery(".playyt_video")[0].src += "&autoplay=1";
      ev.preventDefault();
  });
  
  /*video modal script end*/

$('.video-review-item .play-icon').on('click', function() {
  $(this).parents('.video-review-item').find('[data-video-youtube]').show();
  $('.halo-modal.popup--video').show();
})

// $(document).on("click",".custom-play-video-btn",function() {  
//  console.log('lll')
//   $(this).hide();
//    var newsrc = $('.youtube-pr iframe').attr('src');
//       newsrc = newsrc.remove('?autoplay=1');
//   console.log('newsrc',newsrc)
// 	var src = $(this).parents('.youtube-pr').find('iframe').attr('src');
//         src += "?autoplay=1";
//     console.log('src',src)
//     $(this).parents('.youtube-pr').find('iframe').attr('src',src);    
// }); 


  
  $('.logo-block').slick({
    infinite: true,
    slidesToShow: 4, 
    slidesToScroll: 1, 
    arrows: false, 
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          autoplay: true,
          autoplaySpeed: 0,
          speed: 8000,
          pauseOnHover: false,
          cssEase: 'linear',
          arrows: false,
          slidesToShow: 3, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 2, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 576,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 2, 
          variableWidth: true,
          //slidesToScroll: 1, 
          dots: false,
        }
      }
    ]
  });

  $('.video-review-slider').slick({
    infinite: true,
    slidesToShow: 1,
    variableWidth: true,
    arrows: false, 
    dots: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          infinite: true,
          slidesToShow: 1,
          autoplay: false,
          arrows: false,
          variableWidth: true,
          centerMode: true,
          dots: false,
        }
      }
    ]
  });

  $('.testimonial_cars').slick({
    infinite: true,
    slidesToShow: 1, 
    slidesToScroll: 1, 
    arrows: false, 
    dots: true,
    autoplay: false
  });
  
  $('.logo-column').slick({
    infinite: true,
    slidesToShow: 5, 
    slidesToScroll: 1, 
    arrows: false, 
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          autoplay: true,
          autoplaySpeed: 0,
          speed: 8000,
          pauseOnHover: false,
          cssEase: 'linear',
          arrows: false,
          slidesToShow: 3, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 2, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 576,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 2, 
          variableWidth: true,
          //slidesToScroll: 1, 
          dots: false,
        }
      }
    ]
  });

  /*if (window.matchMedia("(max-width: 991px)").matches) {
    $('.logo-multi-6').slick({
      infinite: true,
      arrows: false, 
      dots: false,
      autoplay: true,
      slidesToShow: 5,
      variableWidth: true,
      autoplaySpeed: 0,
      speed: 6000,
      pauseOnHover: false,
      cssEase: 'linear',
    });
    $('.logo-multi-5').slick({
      infinite: true,
      arrows: false, 
      dots: false,
      autoplay: true,
      slidesToShow: 4,
      variableWidth: true,
      autoplaySpeed: 0,
      speed: 8000,
      pauseOnHover: false,
      cssEase: 'linear',
    });
    $('.logo-multi-4').slick({
      infinite: true,
      arrows: false, 
      dots: false,
      autoplay: true,
      slidesToShow: 3,
      variableWidth: true,
      autoplaySpeed: 0,
      speed: 9000,
      pauseOnHover: false,
      cssEase: 'linear',
    });
  }*/
  
  $('.testimonials-slider').slick({
    infinite: true,
    slidesToShow: 3, 
    slidesToScroll: 1, 
    arrows: false, 
    autoplay: false,
    centerMode: true,
    dots: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          autoplay: false,
          arrows: false,
          slidesToShow: 1, 
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '25%',
          dots: true,
        }
      }
    ]
  });

  $('.trustpilot-slider').slick({
    infinite: true,
    slidesToShow: 3, 
    slidesToScroll: 1, 
    arrows: false, 
    autoplay: false,
    autoplaySpeed: 2000,
    centerMode: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          autoplay: false,
          autoplaySpeed: 2000,
          arrows: false,
          slidesToShow: 2, 
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '25%',
          dots: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: false,
          autoplaySpeed: 2000,
          arrows: false,
          slidesToShow: 1, 
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '25%',
          dots: false,
        }
      }
    ]
  });

  $('.list-blogs').slick({
    infinite: true,
    slidesToShow: 3, 
    slidesToScroll: 1, 
    centerMode: true,
    centerPadding: '60px',
    arrows: false, 
    autoplay: true,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 2, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 576,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 1, 
          slidesToScroll: 1, 
          dots: false,
        }
      }
    ]
  });

  $('.product_slider').slick({
    infinite: true,
    slidesToShow: 3, 
    slidesToScroll: 1, 
    arrows: true, 
    centerMode: false,
    autoplay: true,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 2, 
          slidesToScroll: 1, 
          dots: true,
        }
      },
      {
        breakpoint: 575,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 1, 
          slidesToScroll: 1, 
          dots: true,
        }
      }
    ]
  });

  $('.expert-slider').slick({
    infinite: true,
    slidesToShow: 4, 
    slidesToScroll: 1, 
    arrows: false, 
    centerMode: false,
    autoplay: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 3, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 2, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 576,
        settings: {
          autoplay: true,
          arrows: false,
          centerMode: true,
          slidesToShow: 1, 
          slidesToScroll: 1, 
          dots: false,
        }
      }
    ]
  });

  $('.stcompare-slide').slick({
    infinite: true,
    slidesToShow: 1, 
    slidesToScroll: 1, 
    centerMode: false,
    centerPadding: '42px',
    //autoplaySpeed: 3000,
    arrows: true, 
    dots: false,
    autoplay: false,
  });
  
  $('.press-slider .row').slick({
    infinite: true,
    slidesToShow: 4, 
    slidesToScroll: 1, 
    centerMode: false,
    centerPadding: '42px',
    //autoplaySpeed: 3000,
    arrows: false, 
    dots: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          autoplay: false,
          arrows: false,
          slidesToShow: 3, 
          slidesToScroll: 1, 
          centerMode: false,
          dots: false,
        }
      },
      {
        breakpoint: 576,
        settings: {
          autoplay: true,
          arrows: false,
          centerMode: false,
          slidesToShow: 2, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 481,
        settings: {
          autoplay: true,
          arrows: false,
          centerMode: false,
          slidesToShow: 1, 
          slidesToScroll: 1, 
          dots: false,
        }
      }
    ]
  });

  $('.doctor_reviews').slick({
    infinite: true,
    slidesToShow: 1, 
    slidesToScroll: 1, 
    arrows: false, 
    autoplay: true,
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          autoplay: true,
          arrows: false,
          slidesToShow: 3, 
          slidesToScroll: 1, 
          centerMode: true,
          dots: false,
        }
      }
    ]
  });
  /*jQuery('.doctor_reviews .slick-active').prev().addClass('mobile-left');
    jQuery('.doctor_reviews .slick-active').next().addClass('mobile-right');
    jQuery('.doctor_reviews').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        jQuery('.doctor_reviews .slick-slide').eq(nextSlide).siblings().removeClass('hide');
        jQuery('.doctor_reviews .slick-slide').eq(nextSlide).addClass('hide');
        jQuery('.doctor_reviews .slick-slide').eq(nextSlide - 1).addClass('hide');
        jQuery('.doctor_reviews .slick-slide').eq(nextSlide - 2).addClass('hide');
        jQuery('.doctor_reviews .slick-slide').removeClass('mobile-left');
        jQuery('.doctor_reviews .slick-slide').removeClass('mobile-right');
        jQuery('.doctor_reviews .slick-slide').eq(nextSlide).addClass('mobile-left');
        jQuery('.doctor_reviews .slick-slide').eq(nextSlide + 2).addClass('mobile-right');
    });*/

  $('.product_slider_inner').slick({
    infinite: true,
    slidesToShow: 1, 
    slidesToScroll: 1, 
    arrows: false, 
    dots: true
  });

  $('.skins_slider').slick({
    infinite: true,
    slidesToShow: 1, 
    slidesToScroll: 1, 
    arrows: false, 
    dots: false,
    asNavFor: '.skins_slider_nav',
  });
  $('.skins_slider_nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.skins_slider',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          slidesToShow: 3, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          slidesToShow: 1, 
          slidesToScroll: 1, 
          dots: false,
        }
      }
    ]
  });
  
  $('.compare_slider').slick({
    infinite: true,
    slidesToShow: 5, 
    slidesToScroll: 1, 
    arrows: false,
    draggable: false,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 4, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 3, 
          slidesToScroll: 1, 
          dots: false,
        }
      },
      {
        breakpoint: 481,
        settings: {
          arrows: false,
          slidesToShow: 2, 
          slidesToScroll: 1,
          draggable: false,
          swipe: false,
          touchMove: false,
          autoplay:true,
          centerMode: true,
          centerPadding: '20px',
          dots: false,
        }
      }
    ]
  });

  $('.case-slider').slick({
    infinite: true,
    slidesToShow: 1, 
    slidesToScroll: 1, 
    arrows: true,
    accesibility: false,
   /* draggable: false,
swipeToSlide: false,
touchMove: false,*/


    draggable: false,
swipe: false,
swipeToSlide: false,
touchMove: false,
draggable: false,
accessibility: false,
    dots: false
  });

  $('.timeline_slider').slick({
    infinite: true,
    slidesToShow: 3, 
    slidesToScroll: 1, 
    arrows: false,
    draggable: false,
    dots: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 2, 
          slidesToScroll: 1, 
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 2, 
          slidesToScroll: 1, 
          dots: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1, 
          slidesToScroll: 1, 
          dots: true,
        }
      }
    ]
  });

$('.home_video_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true, 
  accessibility: true,
  swipeToSlide: false,
  draggable: false,
  autoplaySpeed: 4000,
  arrows: false,
  dots: true,
  cssEase:'linear'
});
  
$('.slider-for').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   dots: false,
   asNavFor: '.slider-nav'
 });
 $('.slider-nav').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   asNavFor: '.slider-for',
   arrows: true,
   dots: false,
   focusOnSelect: true,
   responsive: [
    {
      breakpoint: 376,
      settings: {
        arrows: true,
        slidesToShow: 3, 
        slidesToScroll: 1, 
        dots: false,
      }
    }
  ]
 });

$('.custom-pro-recomn-slider').slick({
  infinite: true,
  slidesToShow: 4, 
  slidesToScroll: 1, 
  autoplay: true,
  autoplaySpeed: 3000,
  centerMode: false,
  arrows: false, 
  dots: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows: false,
        slidesToShow: 3, 
        slidesToScroll: 1, 
        dots: false,
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 2, 
        slidesToScroll: 1, 
      }
    },
    {
      breakpoint: 576,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 1, 
        slidesToScroll: 1, 
      }
    }
  ]
});  

/*Product thumb start*/
$('.product_vimp').slick({
  infinite: false,
  slidesToShow: 1, 
  slidesToScroll: 1, 
  arrows: false, 
  autoplaySpeed: 3000,
  autoplay: true,
  dots: true
}); 
/*Product thumb end*/

$('.sauna_benifit_slide').slick({
  infinite: true,
  slidesToShow: 1, 
  slidesToScroll: 1, 
  autoplay: false,
  autoplaySpeed: 3000,
  centerMode: false,
  arrows: true, 
  dots: false,
});  
  
$('.sauna-wrap-zero-emf .sauna_lamobile').slick({
  infinite: false,
  slidesToShow: 4, 
  slidesToScroll: false, 
  autoplay: false,
  autoplaySpeed: 3000,
  centerMode: false,
  arrows: false, 
  dots: false,
  vertical: true,
  focusOnSelect: true,
  asNavFor: '.sauna-wrap-zero-emf .sauna_lamobile_content'
});  
$('.sauna-wrap-zero-emf .sauna_lamobile_content').slick({
  infinite: false,
  slidesToShow: 3, 
  slidesToScroll: 1, 
  autoplay: false,
  autoplaySpeed: 3000,
  centerMode: false,
  arrows: false, 
  dots: false,
  vertical: true,
  focusOnSelect: true,
  asNavFor: '.sauna-wrap-zero-emf .sauna_lamobile',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        infinite: true,
        autoplay: false,
        arrows: true,
        slidesToShow: 1, 
        slidesToScroll: 1, 
        vertical: false,
        focusOnSelect: false,
        dots: false,
      }
    }
  ]
}); 

$('.pemf-product .sauna_lamobile').slick({
  infinite: false,
  slidesToShow: 6, 
  slidesToScroll: false, 
  autoplay: false,
  autoplaySpeed: 3000,
  centerMode: false,
  arrows: false, 
  dots: false,
  vertical: true,
  focusOnSelect: true,
  asNavFor: '.pemf-product  .sauna_lamobile_content'
});  
$('.pemf-product .sauna_lamobile_content').slick({
  infinite: false,
  slidesToShow: 5, 
  slidesToScroll: 1, 
  autoplay: false,
  autoplaySpeed: 3000,
  centerMode: false,
  arrows: false, 
  dots: false,
  vertical: true,
  focusOnSelect: true,
  asNavFor: '.pemf-product .sauna_lamobile',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        infinite: true,
        autoplay: false,
        arrows: true,
        slidesToShow: 1, 
        slidesToScroll: 1, 
        vertical: false,
        centerMode: false,
        focusOnSelect: false,
        dots: false,
      }
    }
  ]
}); 
  
$('.lip_img_slide').slick({
  infinite: true,
  slidesToShow: 1, 
  slidesToScroll: 1, 
  autoplay: true,
  autoplaySpeed: 3000,
  centerMode: false,
  arrows: false, 
  dots: true,
});  

$('.wave-slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   dots: false,
   fade: true,
   asNavFor: '.wave-slider-thumb'
 });

$('.wave-slider-thumb').slick({
   slidesToShow: 3,
   slidesToScroll: 1,
   asNavFor: '.wave-slider',
   arrows: false,
   dots: false,
   focusOnSelect: true,
});  

$('.stvideo_slider').slick({
  infinite: true,
  slidesToShow: 1, 
  slidesToScroll: 1, 
  centerMode: true,
  centerPadding: '42px',
  autoplaySpeed: 3000,
  arrows: false, 
  dots: true,
  autoplay: true,
});

$('.tab-slider').slick({
  infinite: true,
  slidesToShow: 1, 
  slidesToScroll: 1, 
  arrows: true,
  accesibility: false,
  draggable: false,
  swipe: false,
  swipeToSlide: false,
  touchMove: false,
  draggable: false,
  accessibility: false,
    dots: false
});
  
$('button[data-toggle="tab"]').on('shown.bs.tab', function(e) {
  $('.tab-slider').slick('setPosition');
})
  

$('.product-centermode').slick({
  infinite: true,
  slidesToShow: 7, 
  slidesToScroll: 1, 
  centerMode: true,
  centerPadding: '78px',
  arrows: true, 
  dots: false,
  autoplay: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        autoplay: true,
        arrows: true,
        slidesToShow: 5, 
        slidesToScroll: 1, 
        dots: false,
      }
    },
    {
      breakpoint: 768,
      settings: {
        autoplay: true,
        arrows: true,
        slidesToShow: 3, 
        slidesToScroll: 1, 
        dots: false,
      }
    },
    {
      breakpoint: 481,
      settings: {
        autoplay: true,
        arrows: true,
        slidesToShow: 2, 
        slidesToScroll: 1, 
        dots: false,
      }
    }
  ]
});

$('.customer-before-slider').slick({
  infinite: false,
  slidesToShow: 3, 
  slidesToScroll: 1, 
  centerMode: false,
  centerPadding: '78px',
  arrows: false, 
  dots: false,
  autoplay: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        autoplay: false,
        arrows: false,
        slidesToShow: 2, 
        slidesToScroll: 1, 
        dots: false,
      }
    },
    {
      breakpoint: 481,
      settings: {
        autoplay: false,
        arrows: false,
        slidesToShow: 1, 
        slidesToScroll: 1, 
        dots: false,
      }
    }
  ]
});

AOS.init({ once: true, duration: 2000 });

$('.after-cust-btn').click(function(){
  $(this).parents('.slick-slide').find('.before-cust-btn').removeClass('active');
  $(this).parents('.slick-slide').find('.customer-before-col').addClass('active');
  $(this).addClass('active');
});

$('.before-cust-btn').click(function(){
  $(this).parents('.slick-slide').find('.after-cust-btn').removeClass('active');
  $(this).parents('.slick-slide').find('.customer-before-col').removeClass('active');
  $(this).addClass('active');
});
  
$('.skin_item').hover(function(){ 
     $('.skin_item').removeClass('active');
     $(this).addClass('active');
});
$(document).ready(function() { 
    if ($(window).width() <=767 ) {
  var idx = 1;
setInterval(function () {
    $('.skin_treatment ul li').removeClass('active').eq(idx).addClass('active');
    idx++;
    if (idx == $('.skin_treatment ul li').length) idx = 0;
}, 3000);
      }
});

$(document).ready(function() { 
  var idx = 1;
setInterval(function () {
    $('.neuropulse-pro .product-steps .col-xl-4').removeClass('active').eq(idx).addClass('active');
    idx++;
    if (idx == $('.neuropulse-pro .product-steps .col-xl-4').length) idx = 0;
}, 3000);
});
  
$('.accordion_before .card-header h5').click(function(){
  $('.accordion_before .card').removeClass('active');
  $(this).parents('.card').addClass('active');
});
  
  $('.tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('.tabs-nav li').click(function(){
    $('.tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();

    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });

 $('.alphabet').click(function(){
   var letter =  $(this).attr('data-letter');
    $('.alphabet').removeClass('active');
    $(this).addClass('active');
   $('.s-s-accordions .card-item').hide();
   $('.s-s-accordions .card-item .card-header[data-acc-letter="'+letter+'"]').parent('.card').parent('.card-item').show();  
  }); 


//  var Shortdescription = $('.custom-short-description').text();
//     var readMoreBtn = $('.read-more-pro-desc');
//     var maxL = 800;
//     if($('.custom-short-description').text().length > maxL){ 
//        console.log('truuu')
//       var begin = Shortdescription.substr(0, maxL),
//                 end = Shortdescription.substr(maxL);
//   console.log('begin',begin);
// console.log('end',end);

//        $('.custom-short-description').html(begin)
//                 .append($('<a class="readmore"/>').attr('href', '#').html('read more...'))
//                 .append($('<div class="hidden" />').html(end));
//     }
   
    
    // var description = $('.custom-short-description');
    //   var readMoreBtn = $('.read-more-pro-desc');
    //   description.dotdotdot({
    //     ellipsis: '... ',
    //     height: 200, // Adjust this height as needed
    //     watch: true,
    //     callback: function(isTruncated, orgContent) {
    //       if (isTruncated) {
    //         readMoreBtn.show();
    //       }
    //     }
    //   });

    //   readMoreBtn.click(function() {
    //     description.trigger('destroy.dot');
    //     $('.custom-short-description').hide();
    //     $('.remaining-text').show();
    //     readMoreBtn.hide();
    //   });

var description = $('.custom-short-description');
var readMoreBtn = $('.read-more-pro-desc');
var descriptionHeight = $('.custom-short-description').height();
  if(descriptionHeight > 200){
    readMoreBtn.show();
  }else{
    readMoreBtn.hide();
  }
  
  readMoreBtn.click(function() {
      description.addClass('active');
      readMoreBtn.hide();
    });
  
 //  var $this = $('.short-description');
 //  if ($this.find('p').length > 1) {
 //      $('.short-description').append('<div><a data-toggle="modal" data-target="#myProductModal" href="javascript:;" class="showMore"></a></div>');
 //  }

	// $('.short-description p').slice(0,1).addClass('shown');
	// $('.short-description p').not('.shown').hide();
	// $('.short-description .showMore').on('click',function(){
	// 	$('.short-description p').not('.shown').toggle(300);
	// 	$(this).toggleClass('showLess');
	// });

var bodyid = $('body').attr('id') 
 if(bodyid == 'challenge'){
   $('.site-header.header-parallax').addClass('header_background');
 } 

 $('.treatment_tab_nav ul.nav-tabs li.nav-item button').each(function(){
     var t_name = $(this).text().toLowerCase();
      if(localStorage.getItem('cols') == t_name){
        $(this).trigger('click');
      }
  });
  $('.skin_treatment ul li.skin_item a').click(function(e){
      var getname = $(this).text().toLowerCase();
      localStorage.setItem('cols',getname);
  });

 $('.treatment_tab_nav ul.nav-tabs li.nav-item button').click(function(e){
      var tabname = $(this).text().toLowerCase();
      localStorage.setItem('cols',tabname);
  });


jQuery(document).scroll(function(){
  var scroll_top = jQuery(this).scrollTop();
  var header_height = 200;
   if($(window).width() <= 767){
     var header_height = $('.pro-benefit-img').height() + 50;
     $('.lipo-ani-he').each(function(){
      var Index_lipo_sticky_top = jQuery(this).offset().top - header_height -200;
        if(scroll_top >= Index_lipo_sticky_top) {
            $(this).addClass('active');
        }
        else{
          $(this).removeClass('active');
        }
    });
   }else if($(window).width() <= 1199){
     var header_height = 120;
   }
    $('.pro-benefit-content').each(function(){
      var sticky_top = jQuery(this).offset().top - header_height;
        if(scroll_top >= sticky_top) {
            $(this).addClass('active');
        }
        else{
          $(this).removeClass('active');
        }
    });
});

jQuery(document).scroll(function(){
  var scrolls_top = jQuery(this).scrollTop();
  var brain_height = 200;
    if($(window).width() <= 767){
      $('.product-step-bottom').each(function(){
        var stickys_top = jQuery(this).offset().top - brain_height;
          if(scrolls_top >= stickys_top) {
              $(this).addClass('active');
          }
          else{
            $(this).removeClass('active');
          }
      });
    }
});



  $(document).on("click",".qtybox .btnqty",function() {
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty >= 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
    $(this).parents('.item').find('.quantity-trigger .item-quantity').val(qty).trigger('change');
    if(qty == 0){
      $(this).parents('.item').find('.btn-remove-trigger').val(qty).trigger('click');
    }
    // element.addEventListener("change", updateValue);
  }); 

 $(document).on("click",".product-custom-atc",function() {
   $('.shopify-product-form #product-add-to-cart[data-btn-addtocart]').trigger('click')
 })

  
  /*counter start*/
  if($('#counter').length >= 1){
    let a = 0;
    $(window).scroll(function() {
    
      let oTop = $('#counter').offset().top - window.innerHeight;
      
      if (a == 0 && $(window).scrollTop() > oTop) {
        $('.counter').each(function() {
            let $this = $(this);
            jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
                duration: 1000,
                easing: 'swing',
                step: function () {
                    $this.text(Math.ceil(this.Counter));
                }
            });
        });
        a = 1;
      }
    });
  }
    /*counter end*/

$(document).ready(function() {
    var section = $('body.light-therapy-mat .product-benefits');
    var sectionTop = section.offset().top - 100;
    var sectionBottom = sectionTop + section.outerHeight() - 400;
    
    $(window).scroll(function() {
        var scrollPosition = $(window).scrollTop();
        console.log('scrollPosition',scrollPosition);
        console.log('sectionTop',sectionTop)
        console.log('sectionBottom',sectionBottom)
      
        if (scrollPosition >= sectionTop) {
            section.addClass('fixed');
        } else {
            section.removeClass('fixed');
        }
        if (scrollPosition >= sectionBottom) {
            section.addClass('bottom');
            section.removeClass('fixed');
        } else {
            section.removeClass('bottom');
        }
    });
});


  
});  